import React, { useState, useRef, useEffect } from "react";

export default function SliderWithValue({
  label = "Opacity",
  min = 0,
  max = 100,
  step = 1,
  initialValue = 50,
  cooldownMs = 300,
  onChangeCommitted,
}) {
  const [value, setValue] = useState(initialValue);
  const idRef = useRef(`slider-${Math.random().toString(36).slice(2)}`);
  const timeoutRef = useRef(null);

  const clamp = (n) => Math.min(max, Math.max(min, n));

  const scheduleCommit = (nextValue) => {
    if (!onChangeCommitted) {
      return;
    }
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = setTimeout(() => {
      onChangeCommitted(nextValue);
    }, cooldownMs);
  };

  const onSliderChange = (e) => {
    const next = Number(e.target.value);
    setValue(next);
    scheduleCommit(next);
  };

  const onInputChange = (e) => {
    const raw = e.target.value;
    if (raw === "") {
      setValue("");
      return;
    }
    const next = Number(raw);
    if (!Number.isFinite(next)) {
      return;
    }
    const clamped = clamp(next);
    setValue(clamped);
    scheduleCommit(clamped);
  };

  const onInputBlur = () => {
    if (value === "") {
      setValue(initialValue);
      scheduleCommit(initialValue);
    }
  };

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  return (
    <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
      <label htmlFor={idRef.current} style={{ whiteSpace: "nowrap" }}>
        {label}
      </label>

      <input
        id={idRef.current}
        type="range"
        min={min}
        max={max}
        step={step}
        value={value === "" ? min : value}
        onChange={onSliderChange}
        style={{ width: 220 }}
      />

      <input
        type="number"
        min={min}
        max={max}
        step={step}
        value={value}
        onChange={onInputChange}
        onBlur={onInputBlur}
        style={{ width: 70 }}
      />
    </div>
  );
}